import { render, staticRenderFns } from "./stepper.vue?vue&type=template&id=5c44a2c0&"
import script from "./stepper.vue?vue&type=script&lang=js&"
export * from "./stepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/domains/b2b/htdocs/local/templates/b2bmodern_default/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c44a2c0')) {
      api.createRecord('5c44a2c0', component.options)
    } else {
      api.reload('5c44a2c0', component.options)
    }
    module.hot.accept("./stepper.vue?vue&type=template&id=5c44a2c0&", function () {
      api.rerender('5c44a2c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/vue/components/stepper.vue"
export default component.exports